import React from "react";
import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import image, { createImageElement } from "@asserts/images";
import { BannerContents } from "../../../components/shared/layout";

export const BannerHome = (props) => {
  const { images } = props;

  return (
    <BannerContents {...props}>
      <BannerContents.Banner
        backgroundImage={images.bannerHome}
        className="text-white"
      >
        <Row>
          <Col xs={12} className="d-flex align-items-stretch">
            {createImageElement(image.iconHome, {
              className: "d-none d-md-inline-block cvp-icon-banner",
            })}
            <h3 className="d-md-inline-block">CAIXA Vida e Previdência</h3>
          </Col>
          <Col xs={12}>
            <p className="text-body-md mt-0 mt-md-2">
              Seja pra cuidar de si ou de quem ama. Seja pra conquistar mais
              agora ou lá na frente, conheça nossos produtos pensados em você.
            </p>
          </Col>
        </Row>
      </BannerContents.Banner>
    </BannerContents>
  );
};

BannerHome.defaultProps = { images: {} };

BannerHome.propTypes = {
  images: PropTypes.objectOf(Object),
};

export default BannerHome;
